const invertedMessages = {
  'Secure AI agents with built-in visibility, decision attribution, audit readiness and runtime authorization.':
    'external.begin.rules.banner.title',
  'The Saviynt Identity Platform provides continuous visibility into AI agent access and activity, governs access across the agent lifecycle, enforces Zero Standing Privilege, and verifies actions at runtime.':
    'external.begin.rules.banner.description',
  'Begin Identity Security for AI': 'external.begin.rules.banner.button',
} as const;

export default invertedMessages;
